
function hooksWrapper(hooks) {
  const next = hooks.shift();
  return (nextState, replace, done) => {
    if (!next) {
      return done();
    }

    return next(nextState, replace, (err) => {
      if (typeof err === 'boolean' && !err) {
        return done(); // Cancel hook chain if any.
      }
      else if (typeof err !== 'boolean' && err) {
        return done(err); // If hook callsback with error, do not run next
      }

      return hooksWrapper(hooks)(nextState, replace, done);
    });
  };
}

export default function combineHooks(hooks = []) {
  if (!hooks || !(hooks instanceof Array)) {
    throw new Error('hooks must be array of functions.');
  }

  if (hooks.length === 1) {
    return hooks[0];
  }

  return hooksWrapper(hooks);
}



// WEBPACK FOOTER //
// ./shared/react/OnEnterHooks/combineHooks.js